import _ from "lodash";
import { Component } from "react";

class XAPPComponent extends Component {

    constructor(props) {
        super(props);
        if (sessionStorage.getItem("tipo-sistema")) {
            try {
                // eslint-disable-next-line no-undef
                this.dicionario = require(`app/Traducoes/${sessionStorage.getItem("tipo-sistema")}.json`);
            }
            catch (error) {
                this.dicionario = {};
                console.log("Arquivo de dicionario não encontrado.");
            }
        }
    }


    CheckPermission() {
        return true;
    }

    getDicionario(key, standard) {
        if (_.isUndefined((this.dicionario))) {
            return standard;
        }
        return this.dicionario[key] ?? standard;
    }

    existsIntegracao = (_ASistema, _AEmpresa, _ATipo) => {
        return (
            !_.isUndefined(_ASistema[_AEmpresa]) && !_.isNull(_ASistema[_AEmpresa]) &&
            !_.isNull(_ASistema[_AEmpresa].integracao) && _ASistema[_AEmpresa].integracao.includes(_ATipo)
        );
    };
}


export default XAPPComponent;